import { registerComponent } from '@core/alpine-js';
import inspirationsProvider from '../components/inspirations/inspirations-provider';

registerComponent('inspirationsProvider', inspirationsProvider);
